import {Component, Output, EventEmitter, Input} from "@angular/core";

@Component({
	selector: 'cp-popup-buttons-double-ok-cancel',
	template : `
		<cp-button-strip>
			<div class="primary-area">
				<cp-button-widget-custom class="primary-button"
										 [titleToTranslate]="firstOkLabel ? firstOkLabel : 'OK'"
										 [isDisabled]="firstOkDisabled"
										 (onClick)="firstOkDisabled ? null : firstOk.emit();">
				</cp-button-widget-custom>
				<cp-button-widget-custom class="primary-button"
										 [titleToTranslate]="secondOkLabel ? secondOkLabel : 'OK'"
										 [isDisabled]="secondOkDisabled"
										 (onClick)="secondOkDisabled ? null : secondOk.emit();">
				</cp-button-widget-custom>
			</div>
			<div class="secondary-area">
				<cp-button-widget-custom class="tertiary-button"
										 [titleToTranslate]="cancelLabel ? cancelLabel : 'Cancel'"
										 (onClick)="cancel.emit();">
				</cp-button-widget-custom>
			</div>
		</cp-button-strip>
`
})
export class PopupButtonsDoubleOkCancelComponent {

	@Input() firstOkLabel: string;
	@Input() secondOkLabel: string;
	@Input() cancelLabel: string;
	@Input() firstOkDisabled: boolean;
	@Input() secondOkDisabled: boolean;

	@Output() firstOk = new EventEmitter();
	@Output() secondOk = new EventEmitter();
	@Output() cancel = new EventEmitter();
}
